import React from "react"
import { Link } from "gatsby"
import styled from "@emotion/styled"

import Logo from "../../images/brand/logo.svg"

const Outer = styled.div`
  height: 100%;
  width: 100%;
  display: grid;
  row-gap: 32px;
  grid-template-columns:
    minmax(24px, auto) minmax(auto, ${props => props.theme.maxWidth})
    minmax(24px, auto);
  padding: 96px 0;
  border-top: 1px solid ${props => props.theme.shade[90]};
  background-color: ${props =>
    props.backgroundColor ? props.backgroundColor : "#ffffff"};
`
const Inner = styled.div`
  width: 100%;
  display: grid;
  grid-column: 2;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 32px;
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 32px;
  }
  @media (max-width: ${props => props.theme.breakpoints.xs}) {
    grid-template-columns: 1fr;
    grid-gap: 24px;
  }
`
const FooterLink = styled(Link)`
  display: block;
  color: ${props => props.theme.shade[10]};
  text-decoration: none;
  margin: 8px 0;
`
const LogoImg = styled.img`
  width: 100%;
  max-width: 160px;
  margin-bottom: 8px;
`
const Column = styled.div``
const ColumnBrand = styled.div``
const NavHeader = styled.h4`
  color: ${props => props.theme.shade[0]};
`
const Address = styled.div`
  p {
    margin-bottom: 0;
  }
`
const Details = styled.div`
  text-align: right;
  p {
    color: ${props => props.theme.shade[30]};
    :first-of-type {
      margin-top: 16px;
    }
    margin: 0;
  }
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    text-align: left;
  }
`
const MailLink = styled.a`
  color: ${props => props.theme.shade[10]};
`

export default function Footer(props) {
  return (
    <Outer>
      <Inner>
        <ColumnBrand>
          <LogoImg src={Logo} alt="DevelRx Logo" />
          <Address>
            <p>Biocity,</p>
            <p>Pennyfoot Street,</p>
            <p>Nottingham,</p>
            <p>Nottinghamshire,</p>
            <p>NG1 1GF</p>
          </Address>
        </ColumnBrand>
        <Column>
          <NavHeader>Legal</NavHeader>
          <FooterLink to="/legal/cookie-policy/">Cookie Policy</FooterLink>
          <FooterLink to="/legal/privacy-policy/">Privacy Policy</FooterLink>
          <FooterLink to="/legal/terms/">Terms &amp; Conditions</FooterLink>
        </Column>
        <Column>
          <NavHeader>Pages</NavHeader>
          <FooterLink to="/">Home</FooterLink>
          <FooterLink to="/team/">Team</FooterLink>
          <FooterLink to="/news/">News &amp; events</FooterLink>
          <FooterLink to="/publications/edited-books-and-special-issues/">
            Publications
          </FooterLink>
          <FooterLink to="/services/research-candidate-selection/">
            Services
          </FooterLink>
          <FooterLink to="/partners/">Partners</FooterLink>
          <FooterLink to="/contact/">Contact</FooterLink>
        </Column>
        <Details>
          <MailLink href="mailto:inform@develrx.com">
            inform@develrx.com
          </MailLink>
          <p>
            Follow us on{" "}
            <a
              href="https://www.linkedin.com/company/develrx-ltd/"
              target="_blank"
              rel="noreferrer"
            >
              LinkedIn
            </a>
          </p>
          <p>Registered in England and Wales</p>
          <p>Company number: 12028847</p>
        </Details>
      </Inner>
    </Outer>
  )
}
